import { render, staticRenderFns } from "./formbuilderView.vue?vue&type=template&id=ab131a84&scoped=true"
import script from "./formbuilderView.vue?vue&type=script&lang=js"
export * from "./formbuilderView.vue?vue&type=script&lang=js"
import style0 from "./formbuilderView.vue?vue&type=style&index=0&id=ab131a84&prod&lang=scss&scoped=true"
import style1 from "./formbuilderView.vue?vue&type=style&index=1&id=ab131a84&prod&lang=scss"
import style2 from "./formbuilderView.vue?vue&type=style&index=2&id=ab131a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab131a84",
  null
  
)

export default component.exports